import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { tagsApi, Tag } from '../api/tags';

interface TagDisplayProps {
  entityType: 'lead' | 'account' | 'contact';
  entityId: number;
  className?: string;
}

const TagDisplay: React.FC<TagDisplayProps> = ({ entityType, entityId, className = '' }) => {
  const { data: tags = [], isLoading } = useQuery({
    queryKey: ['tags', entityType, entityId],
    queryFn: () => tagsApi.getByEntity(entityType, entityId),
    enabled: !!entityId,
  });

  if (isLoading) {
    return null;
  }

  if (tags.length === 0) {
    return null;
  }

  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`}>
      {tags.map((tag: Tag) => (
        <span
          key={tag.id}
          className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
          style={{
            backgroundColor: tag.color ? `${tag.color}20` : '#3B82F620',
            color: tag.color || '#3B82F6',
            border: `1px solid ${tag.color || '#3B82F6'}40`,
          }}
          title={tag.description || tag.name}
        >
          <span
            className="w-1.5 h-1.5 rounded-full mr-1"
            style={{ backgroundColor: tag.color || '#3B82F6' }}
          />
          {tag.name}
        </span>
      ))}
    </div>
  );
};

export default TagDisplay;

